"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = (config, instance) => {
  const lpbPrefix = config.apiPrefixes.lpb;
  return {
    getAppconfig() {
      return instance.get('/appconfig', {
        baseURL: lpbPrefix
      });
    }
  };
};
exports.default = _default;